import { TenderOpeningStateTypes, TenderOpeningActionTypes } from "./TenderOpening.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: TenderOpeningStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const TenderOpeningReducer = (
  state: TenderOpeningStateTypes = INITIAL_STATE,
  action: any
): TenderOpeningStateTypes => {
  switch (action.type) {
    case TenderOpeningActionTypes.FETCH_ALL_TENDER_OPENING:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case TenderOpeningActionTypes.FETCH_ALL_TENDER_OPENING_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TenderOpeningActionTypes.FETCH_ALL_TENDER_OPENING_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TenderOpeningActionTypes.FETCH_ALL_TENDER_OPENING_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case TenderOpeningActionTypes.FETCH_ONE_TENDER_OPENING:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case TenderOpeningActionTypes.FETCH_ONE_TENDER_OPENING_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TenderOpeningActionTypes.FETCH_ONE_TENDER_OPENING_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TenderOpeningActionTypes.FETCH_ONE_TENDER_OPENING_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default TenderOpeningReducer;
